/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { NodePath } from '../../core/models/NodePath';
import { IOasHeaderParent } from '../../openapi/models/IOasHeaderParent';
import { OasHeader } from '../../openapi/models/OasHeader';
import { MarshallCompat } from '../../compat/MarshallCompat';
import { Node } from '../../core/models/Node';

/**
 * @author vvilerio
 * @extends AbstractCommand
 * @class
 */
export class ChangeHeaderCommand extends AbstractCommand {
    public _parentPath : NodePath;

    public _headerName : string;

    public _newHeader : any;

    public _changed : boolean;

    public _oldHeader : any;

    public constructor(header? : any, newHeader? : any) {
        if(((header != null && header instanceof <any>OasHeader) || header === null) && ((newHeader != null && newHeader instanceof <any>OasHeader) || newHeader === null)) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._headerName===undefined) this._headerName = null;
            if(this._newHeader===undefined) this._newHeader = null;
            if(this._changed===undefined) this._changed = false;
            if(this._oldHeader===undefined) this._oldHeader = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._headerName===undefined) this._headerName = null;
            if(this._newHeader===undefined) this._newHeader = null;
            if(this._changed===undefined) this._changed = false;
            if(this._oldHeader===undefined) this._oldHeader = null;
            (() => {
                this._headerName = header.getName();
                this._parentPath = Library.createNodePath(header);
                this._newHeader = Library.writeNode(newHeader);
            })();
        } else if(header === undefined && newHeader === undefined) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._headerName===undefined) this._headerName = null;
            if(this._newHeader===undefined) this._newHeader = null;
            if(this._changed===undefined) this._changed = false;
            if(this._oldHeader===undefined) this._oldHeader = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._headerName===undefined) this._headerName = null;
            if(this._newHeader===undefined) this._newHeader = null;
            if(this._changed===undefined) this._changed = false;
            if(this._oldHeader===undefined) this._oldHeader = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[ChangeHeaderCommand] Executing.");
        this._changed = false;
        let parent : IOasHeaderParent = <IOasHeaderParent><any>this._parentPath.resolve(document);
        if(this.isNullOrUndefined(parent)) {
            return;
        }
        let header : OasHeader = <OasHeader>parent.getHeader(this._headerName);
        if(this.isNullOrUndefined(header)) {
            return;
        }
        this._oldHeader = Library.writeNode(header);
        let newHeader : OasHeader = parent.createHeader(this._headerName);
        Library.readNode(this._newHeader, newHeader);
        this.doChangeHeader(header, newHeader);
        this._changed = true;
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[ChangeHeaderCommand] Reverting.");
        if(!this._changed) {
            return;
        }
        let parent : IOasHeaderParent = <IOasHeaderParent><any>this._parentPath.resolve(document);
        if(this.isNullOrUndefined(parent)) {
            return;
        }
        let header : OasHeader = <OasHeader>parent.getHeader(this._headerName);
        if(this.isNullOrUndefined(header)) {
            return;
        }
        let oldHeader : OasHeader = parent.createHeader(this._headerName);
        Library.readNode(this._oldHeader, oldHeader);
        this.doChangeHeader(header, oldHeader);
    }

    /**
     * doChangeHeader
     * 
     * @param {OasHeader} from
     * @param {OasHeader} to
     */
    doChangeHeader(from : OasHeader, to : OasHeader) {
        let parent : IOasHeaderParent = <IOasHeaderParent><any>from.parent();
        parent.removeHeader(this._headerName);
        parent.addHeader(this._headerName, to);
    }
}
ChangeHeaderCommand["__class"] = "io.apicurio.datamodels.cmd.commands.ChangeHeaderCommand";
ChangeHeaderCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




